<template>

    <div>
        <template v-if="toolType === 'firestop' || toolIcon === 'custom'">
            <FirestopMarkingIcon
                :bottom-text="bottomText"
                :marking-color="color"
                :middle-text="middleText"
                :middle-text-color="toolIcon === 'red-pen' ? 'red' : '#000000'"
                :style="'width:' + width + 'px; height:' + height + 'px;'"
                :top-text="topText"
            ></FirestopMarkingIcon>
        </template>
        <template v-else-if="toolIcon === 'multiline' || toolIcon === 'arrow' || toolIcon === 'area'">
            <div :class="toolIcon" class="markingIcon" :style="'width:' + width + 'px; height:' + height + 'px;'">
                <FirestopMarkingIcon
                    :bottom-text="bottomText"
                    :marking-color="color"
                    :middle-text="middleText"
                    :middle-text-color="toolIcon === 'red-pen' ? 'red' : '#000000'"
                    :style="'width:' + (width - 30) + 'px; height:' + (height-30) + 'px;'"
                    :top-text="topText"></FirestopMarkingIcon>
            </div>
        </template>

    </div>

</template>

<script>
import FirestopMarkingIcon from "@mobile/components/global/Markings/FirestopMarkingIcon";

export default {
    components: {FirestopMarkingIcon},
    name: "Icon",
    props: {
        toolType: {
            type: String,
            default: 'custom',
            required: true
        },
        toolIcon: {
            type: String,
            default: 'custom',
            required: true
        },
        color: {
            type: String,
            required: false,
            default: '#000000'
        },
        topText: {
            type: String,
            required: false,
            default: null
        },
        middleText: {
            type: String,
            required: false,
            default: null
        },
        bottomText: {
            type: String,
            required: false,
            default: null
        },
        width: {
            type: Number,
            required: false,
            default: 100
        },
        height: {
            type: Number,
            required: false,
            default: 100
        }
    }
}
</script>

<style scoped>
.markingIcon {
    background-repeat: no-repeat;
    background-size: 30px 30px;
    background-position: bottom left;
    text-align: right;
    position: relative;
}

.markingIcon.multiline {
    background-image: url(~@images/tools/multiline-icon.svg);
    background-size: 30px 48px;
}

.markingIcon.arrow {
    background-image: url(~@images/tools/arrow-icon.svg);
    background-size: 40px 40px;
}
.markingIcon.area:before {
    position: absolute;
    content: '';
    width: 30px;
    height: 30px;
    border: dashed 2px #000;
    bottom: 0;
    left: 0;
}
</style>
